export default "__VITE_ASSET__71e4132b__"